import React from "react";
import { ProviderUser } from "../domain/types/ProviderUser";
import { Bank } from "../domain/types/banks/Bank";
import { BankAccount } from "../domain/types/banks/BankAccount";
import BankAccountsList from "./BankAccountsList";

interface Props {
  member: ProviderUser;
  accountsByBank: { [bankId: string]: BankAccount[] };
  banks: { [key: string]: Bank };
  sharedAccounts: Set<string>;
}

const FamilyMemberSection: React.FC<Props> = ({
  member,
  accountsByBank,
  banks,
  sharedAccounts,
}) => {
  // Since family members' accounts cannot be deleted by the current user,
  // we pass an empty set for deletingAccountIds
  const deletingAccountIds = new Set<string>();

  return (
    <section className="relative pb-10">
      <div className="container relative mx-auto px-4 mt-8">
        <div className="rounded-md shadow dark:shadow-gray-700 bg-white dark:bg-slate-900">
          <div className="flex flex-col md:flex-row md:justify-between items-center p-6 border-b border-gray-100 dark:border-gray-700">
            <h5 className="text-xl font-semibold text-center md:text-left mb-4 md:mb-0">
              {member.displayName}&#39;s Connected Bank Accounts
            </h5>
          </div>
          <div className="p-6">
            <BankAccountsList
              banks={banks}
              accountsByBank={accountsByBank}
              sharedAccounts={sharedAccounts}
              deletingAccountIds={deletingAccountIds}
              isOwner={false}
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default FamilyMemberSection;
